import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
  },
  searchIcon: {
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(14),
    },
  },
  changeStatusBtn: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 500,
  },
}));

export default useStyles;
